import React, { ReactElement } from "react";
import { GetServerSideProps } from "next";
import { getPageProps } from "@services/initial-calls";
import TopCampLejeuneLawyersWrapper from "@components/layouts/topCampLejeuneLawyersWrapper";
import ContactTop from "@components/antiviruschoice/contactTop";
import FormSection from "@components/antiviruschoice/formSection";

export default function CampLejeuneApplicationHome(): ReactElement {
    return (
        <TopCampLejeuneLawyersWrapper footerBgColor="#fff">
            <div className="bg-white">
                <ContactTop iconsFillColor="#bf2628" />
            </div>
            <FormSection iconsFillColor="#bf2628" />
        </TopCampLejeuneLawyersWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Contact Us" });
};
